<template>
  <div class="NetlifyIdentityAdmin">
    <div 
      class="d-flex">
      <h1 
        v-if="usersLoaded && users.length"
        class="text-left mb-3 flex-grow-1 ml-5">
        Gebruikersbeheer
      </h1>
      <div 
        v-if="usersLoaded && users.length"
        class="mb-3 mr-5 d-flex align-items-center justify-content-end">
        <b-button 
          size="lg"
          type="submit"
          variant="primary"
          :disabled="!usersLoaded"
          @click="handleAddUser">
          Gebruiker toevoegen
        </b-button>
      </div>
    </div>
    <div 
      v-if="!usersLoaded"
      class="mt-4 pt-2 mb-5 d-flex">
      Loading...
    </div>
    <NetlifyIdentityUserTable
      v-else-if="users.length"
      :users="users"
      title="Organisatie Naam"
      class="mt-4 pt-2 mb-5"
      @refresh="handleRefresh"
      @edit="handleEdit" />
    <div 
      v-else
      class="mt-4 pt-2 mb-5 d-flex flex-column">
      <p>Fout bij inladen van gebruikers.</p>
    </div>

    <NetlifyIdentityUserModal
      :userId="userId"
      @refresh="handleRefresh" />
  </div>
</template>

<script>


import { listUsers } from 'service/netlifyIdentity'

import NetlifyIdentityUserTable from '@/components/NetlifyIdentityAdmin/NetlifyIdentityUserTable'
import NetlifyIdentityUserModal from '@/components/NetlifyIdentityAdmin/NetlifyIdentityUserModal'

import { isAdmin } from 'service/auth'

export default {
  name: 'Admin',
  components: {
    NetlifyIdentityUserTable,
    NetlifyIdentityUserModal
  },
  data() {
    return {
      page: 1,
      users: [],
      usersLoaded: false,

      //
      userId: null
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!isAdmin()) {
      next(false)
    } else {
      next()
    }
  },
  created() {
    this.getUsers()
  }, 
  methods: {
    async getUsers() {
      let response = await listUsers({ page: this.page })
      if (response.status === 200) {
        this.users = response.data.users
      } 
      
      this.usersLoaded = true
    },
    handleAddUser() {
      this.userId = null
      let vm = this
      this.$nextTick(() => {
        vm.$bvModal.show('modal-netlifyidentityuser')
      })
    },
    // Get users again
    // TODO: Make this more intelligent...
    handleRefresh() {
      this.userId = null
      this.getUsers()
    },
    handleEdit({ id }) {
      this.userId = id
      let vm = this
      this.$nextTick(() => {
        vm.$bvModal.show('modal-netlifyidentityuser')
      })
    }
  }

}
</script>
